module.exports = __webpack_public_path__ + "img/sentida_6.fd4376c5.png";